import Link from "next/link";
import { ArrowRightLong } from "./ArrowComponents";
import Image from "next/image";
import { returnUrlTypeCategory } from "~/utils/utils";

const SpecialiComponent = ({ data, tax }) => {
  const singleTerm = data.item.term;
  return (
    <div
      key={data.id}
      className="border-box border-box flex w-full break-inside-avoid flex-col border-b border-gray pb-16 print:px-0"
    >
      <figure className="block pb-11">
        <Link
          href={`${returnUrlTypeCategory(singleTerm.slug, tax).replace(
            "&amp;",
            " & "
          )}`}
          className="flex w-full rounded-[50px] bg-lightLightGray"
        >
          {singleTerm.img != null && (
            <Image
              src={singleTerm.img}
              width={500}
              height={400}
              alt={singleTerm?.img || "immagine di copertina"}
              sizes="(min-width: 769px) 50vw, (min-width: 1281px) 33vw, 100vw"
              loading="lazy"
              className="!aspect-4/3 h-full w-full rounded-[50px] object-cover mix-blend-multiply hover:opacity-80"
            />
          )}
        </Link>
      </figure>
      {singleTerm.numeroSlug != null && (
        <Link
          className="flex pb-6 font-bold uppercase text-orange"
          href={`/n/${singleTerm.numeroSlug}`}
        >
          BS {singleTerm.numeroName}
        </Link>
      )}

      <h3>
        <Link
          className="text-3xl uppercase text-black hover:underline"
          href={`${returnUrlTypeCategory(singleTerm.slug, tax).replace(
            "&amp;",
            " & "
          )}/`}
        >
          {singleTerm.name}
        </Link>
      </h3>

      <ArrowRightLong
        href={`${returnUrlTypeCategory(singleTerm.slug, tax).replace(
          "&amp;",
          " & "
        )}/`}
        color={"black"}
        message={"Leggi tutti gli articoli"}
        divStyles={"pt-9"}
      />
    </div>
  );
};

export default SpecialiComponent;
